import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 100 100" {...props}>
      <title id="Tempo">{props.title || 'Tempo'}</title>
      <g>
        <path d="M95 23.4l-3.7-3.6-7.4 7.5-4.3-4.3-5.7 9.9 2.2 2.2-8.9 9-5.3-32.6c-.4-2.7-3-4.9-5.7-4.9h-32.5c-2.7 0-5.3 2.2-5.8 4.9l-12.9 77.1c-.5 2.7 1.4 4.9 4.1 4.9h61.3c2.7 0 4.6-2.2 4.1-4.9l-6.2-38.2 11.5-11.7 2.2 2.2 9.8-5.8-4.3-4.3 7.5-7.4zm-72.9 46.4c-2.7 0-4.6-2.2-4.2-4.9l7.2-45.2c.4-2.7 3-4.9 5.7-4.9h18.3c2.7 0 5.3 2.2 5.7 4.9l4.9 32.1-14.2 14.4v-.2h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-.4c0-2.7-2.2-4.9-4.9-4.9h-1.5c-2.7 0-4.9 2.2-4.9 4.9v41.8h-12.1zm39.6-4.9c.4 2.7-1.5 4.9-4.2 4.9h-8.3l11.5-11.6 1 6.7z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/tempo.js